import ArquivoContainer from './arquivo.container'

export default ArquivoContainer
